import { render, staticRenderFns } from "./UICreatePostMobileModal.vue?vue&type=template&id=2f54ccee"
import script from "./UICreatePostMobileModal.vue?vue&type=script&lang=js"
export * from "./UICreatePostMobileModal.vue?vue&type=script&lang=js"
import style0 from "./UICreatePostMobileModal.vue?vue&type=style&index=0&id=2f54ccee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
